import React from 'react';
import { connect } from 'react-redux';
import { getEventLog } from '../Actions/log';
import ErrorLogView from '../Components/Log/error';
import { ErrorLog } from '../Entities/ErrorLog';

interface IProps {
    isLoading: boolean;
    error: string;
    page: number;
    pages: number;
    list: ErrorLog[];
    getList: (page?: number) => void;
}

interface IState {
    isLoading: boolean;
    isLogin: boolean;
}

class ErrorLogPage extends React.Component<IProps, IState> {

    async componentDidMount() {
        await this.props.getList();
    }

    onLoadMore = (page: number) => {
        this.props.getList(page);
    }

    render() {
        const { error, isLoading, page, pages, list } = this.props;
        return (
            <ErrorLogView
                error={error}
                isLoading={isLoading}
                list={list}
                page={page}
                pages={pages}
                onLoadMore={this.onLoadMore}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        getList: (page: number = 1) => dispatch(getEventLog(page)),
    };
}

const mapStateToProps = (state: any) => {
    return {
        page: state.log.errorPage,
        pages: state.log.errorPages,
        isLoading: state.log.isLoading,
        list: state.log.errorList,
        error: state.log.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(ErrorLogPage);
